import React, { Component } from "react";
import { getEvents, updateCurrentPage  } from "../store/events";
import { getCurrentUser } from "../store/auth";
import { connect } from "react-redux";
// import Image from "react-image-resizer";
// import Image from "react-bootstrap/Image";
import EventCard from "./eventCard";
import { Container, Row, Col } from "reactstrap";
import Pagination from "./common/pagination";
import { getPagedData} from "../utils/paginate";

class Events extends Component {
  state = { 
    // comingEvents: [], 
    // pastEvents: [], 
    events: [],
    currentPage: 1,
    pageSize: 8, 
    updateCurrentPage: ()=>{}
  };

  getPrevPath = () => this.props.prevPath?this.props.prevPath.pathname:"";

  renderEvents = (events) => {
    return (
      <div className="d-flex">
        <ul className="list-inline mx-auto justify-content-center">
          {events.map((event) => (
            <li key={event._id}>
              <EventCard key={event._id} currentUser={this.props.currentUser} event={event} />
            </li>
          ))}
        </ul>
      </div>
    );
  };

  renderPagination = (totalCount, pageSize, currentPage) =>{
    return (
      <div className="d-flex justify-content-center">
        <Pagination
            itemsCount={totalCount}
            pageSize={pageSize}
            currentPage={currentPage}
            onPageChange={page=>{
              this.setState({currentPage: page})
              this.state.updateCurrentPage(page)
              window.scrollTo(0, 0);
            }}
          />
      </div>
    )
  }
  
  render() {
    const { pageSize, currentPage, events: allEvents } = this.state;

    const { totalCount, data: events } = getPagedData(pageSize, currentPage, allEvents);

    if ( this.state.events.length < 1 ){

      return <div 
        className="d-flex justify-content-center"
        style={{marginTop: 10}}>
        <h3> {this.props.loading? "Loading...": null} </h3>
      </div>
      } 

    return (
      <Container>
        {this.renderPagination(totalCount, pageSize, currentPage)}
        {this.renderEvents(events)}
        {this.renderPagination(totalCount, pageSize, currentPage)}
      </Container>
    );
  }
}

export const mapStateToProps = (state) => ({
  currentUser: state.auth.currentUser,
  events: state.entities.events ? state.entities.events.list : [],
  loading: state.entities.events ? state.entities.events.loading : false,
  currentPage: state.entities.events ? state.entities.events.currentPage : 1
});

export const mapDispatchToProps = (dispatch) => ({
  getEvents: () => dispatch(getEvents()),
  getCurrentUser: () => dispatch(getCurrentUser()),
  updateCurrentPage: (page) => dispatch(updateCurrentPage(page))
});

export default Events;
